import { Component, OnInit } from '@angular/core';
//import { Observable } from 'rxjs';
//import { Language } from 'src/app/models/language.model';
//import { LanguagesService } from 'src/app/services/languages/languages.service';
//import {PrivacyPolicyDeComponent} from "./privacy-policy-de/privacy-policy-de.component";
import {PrivacyPolicyEnComponent} from "./privacy-policy-en/privacy-policy-en.component";
//import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'colimo-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  imports: [
    //PrivacyPolicyDeComponent,
    PrivacyPolicyEnComponent,
    //AsyncPipe
  ]
})
export class PrivacyPolicyComponent implements OnInit {
  //public currentLanguage$: Observable<Language>;

  //constructor(private languagesService: LanguagesService) {}

  public ngOnInit(): void {
    //this.currentLanguage$ = this.languagesService.currentLanguage$;
  }
}
